import { generateConfidenceColors } from "./generateConfidenceColors";
const primary = "45% 0.24 277.023";
const content = "21% 0.006 285.885";

export const lightTheme = {
  name: "light",
  default: false,
  prefersDark: false,
  colorScheme: "light",
  colors: {
    // Base colors
    "base-100": "100% 0 0",
    "base-200": "98% 0 0", 
    "base-300": "95% 0 0",
    "base-content": "21% 0.006 285.885",
    
    // Primary colors
    "primary": "45% 0.24 277.023",
    "primary-content": "93% 0.034 272.788",
    
    // Secondary colors
    "secondary": "65% 0.241 354.308",
    "secondary-content": "94% 0.028 342.258",
    
    // Accent colors
    "accent": "77% 0.152 181.912",
    "accent-content": "38% 0.063 188.416",
    
    // Neutral colors
    "neutral": "14% 0.005 285.823",
    "neutral-content": "92% 0.004 286.32",
    
    // Semantic colors
    "info": "74% 0.16 232.661",
    "info-content": "29% 0.066 243.157",
    "success": "76% 0.177 163.223",
    "success-content": "37% 0.077 168.94",
    "warning": "82% 0.189 84.429",
    "warning-content": "41% 0.112 45.904",
    "error": "71% 0.194 13.428",
    "error-content": "27% 0.105 12.094",
    
    // Confidence levels
    ...generateConfidenceColors(primary, content, false)
  },
  dimensions: {
    "radius-selector": "0.5rem",
    "radius-field": "0.25rem",
    "radius-box": "0.5rem",
    "size-selector": "0.25rem",
    "size-field": "0.25rem",
    "border": "1px",
    "depth": "1",
    "noise": "0"
  }
};
